import { getInitiativesJiraIssueSlice } from '../@async/get';
import { createAddSyncSlice } from '@sonar-software/xuder';
import { InitiativeJiraIssue } from '@api';
import { InitiativeJiraIssuesName } from '../name';

export const initiativesJiraIssueAddSyncSlice = createAddSyncSlice({
	name: InitiativeJiraIssuesName,
	state: getInitiativesJiraIssueSlice.asyncState,
	transform: (action: InitiativeJiraIssue, state = []) => {
		for (var issue of state) {
			if (issue.issueKey === action.issueKey) {
				return state;
			}
		}

		return [ ...state, action ]
	}
});
